"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterPropertiesExportHelper = void 0;
var enums_1 = require("../../core/model/character/enums");
var color_1 = require("../../core/model/color/color");
var CharacterPropertiesExportHelper = (function () {
    function CharacterPropertiesExportHelper() {
    }
    CharacterPropertiesExportHelper.ShouldExportInlinePictureRunCharacterProperties = function (props, colorProvider) {
        return (props.hidden) ||
            (props.fontUnderlineType != enums_1.UnderlineType.None) ||
            (props.fontStrikeoutType != enums_1.StrikeoutType.None) ||
            (props.highlightColor.toRgb(colorProvider) != color_1.ColorHelper.NO_COLOR) ||
            (props.shadingInfo.getActualColor(colorProvider) != color_1.ColorHelper.NO_COLOR);
    };
    return CharacterPropertiesExportHelper;
}());
exports.CharacterPropertiesExportHelper = CharacterPropertiesExportHelper;
